import { render, staticRenderFns } from "./pushDetail.vue?vue&type=template&id=1d1f727c&"
import script from "./pushDetail.vue?vue&type=script&lang=js&"
export * from "./pushDetail.vue?vue&type=script&lang=js&"
import style0 from "./pushDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports